import styles from "../../constants/styles";
import ImageWithTextTile from "./ImageWithTextTile";
import Home from "../../assets/Home.png";
import HomeWithFilters from "../../assets/HomeWithFilters.png";
import Filters from "../../assets/Filters.png";

const Features = () => {
  return (
    <section id="featureSection" className="flex flex-col items-center">
      <h2 className={styles.secondaryHeading}>Features</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 grid-flow-rows gap-4 mx-4">
        <div className="row-start-1 row-end-2">
          <ImageWithTextTile
            heading="1. Load"
            text="Load all the words your learned on Duolingo."
            imageUrl={Home}
          />
        </div>

        <div className="row-start-2 lg:row-start-1 row-end-3 lg:row-end-3">
          <ImageWithTextTile
            heading="2. Filter"
            text="Select the table columns you want. Only include words that you learned after a certain day?"
            imageUrl={Filters}
          />
        </div>

        <div className="row-start-3 lg:row-start-2 row-end-4 lg:row-end-3">
          <ImageWithTextTile
            heading="3. Download"
            text="Download your custom selection."
            imageUrl={HomeWithFilters}
          />
        </div>
      </div>
    </section>
  );
};

export default Features;
